import React from 'react'
import { useTranslation } from 'react-i18next'
import { useField } from 'formik'
import { RequirementCardContainer } from 'components/Shared/Fields/styles'
import CampaignEditorInputFieldContainer from 'components/Shared/Permission/CampaignEditorInputFieldContainer'
import { fieldIdentifiers } from 'components/Shared/Comment'
import RangeInput from 'particles/RangeInput'

interface AgeRequirementProps {
    requirementUuid?: string
    name: string
    onRemove: () => void
}

const AgeRequirement: React.FC<AgeRequirementProps> = ({ requirementUuid, name, onRemove }) => {
    const [t] = useTranslation()
    const [field] = useField(name)
    return (
        <RequirementCardContainer isCard>
            <CampaignEditorInputFieldContainer>
                <RangeInput.Number
                    label={t('submission.table.ageLabel')}
                    subtext={t('campaignEditor.requirement.ageSubtext')}
                    isRequired
                    firstRangeTitle={t('campaignEditor.requirement.enterMinimumAge')}
                    firstRangeName={`${field.name}.min`}
                    firstRangePlaceholder="0"
                    firstRangeIdentifier={`${requirementUuid}_${fieldIdentifiers.ageMin}`}
                    secondRangeTitle={t('campaignEditor.requirement.enterMaximumAge')}
                    secondRangeName={`${field.name}.max`}
                    secondRangePlaceholder="0"
                    secondRangeIdentifier={`${requirementUuid}_${fieldIdentifiers.ageMax}`}
                    onClose={onRemove}
                    width="100%"
                    inputWidth="100%"
                    isFormikComponent
                />
            </CampaignEditorInputFieldContainer>
        </RequirementCardContainer>
    )
}

export default AgeRequirement
